__turbopack_context__.v({
  "buttonsWrapper": "XcrlMa_buttonsWrapper",
  "content": "XcrlMa_content",
  "iconWrapper": "XcrlMa_iconWrapper",
  "infoBoxWrapper": "XcrlMa_infoBoxWrapper",
  "infoText": "XcrlMa_infoText",
  "modalContent": "XcrlMa_modalContent",
  "wrapper": "XcrlMa_wrapper",
});
